import SearchModalResults from './SearchModalResults';

export default SearchModalResults;
